<script lang="ts" setup>
  import type { Dictionary, CustomerType, CountriesDictionary } from '@othercommerce/domain';

  defineProps<{
    data: any;
    registerAgencies: Dictionary;
    medicalPracticeGroups: Dictionary;
    medicalTypes: Dictionary;
    countries: CountriesDictionary,
    regions?: Dictionary;
    customerType: CustomerType;
  }>();

</script>

<template>
  <SfFormTabs :options="medicalTypes" name="rpwdlMedicalType" required />

  <SfFormSelect :label="$t('SHOP.COMMON.LABEL.COUNTRY')" :options="countries" name="countryCode" readonly required />

  <SfFormInput :label="$t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_COMPANY')" name="company" readonly />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.FIRSTNAME')" name="firstName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.LASTNAME')" name="lastName" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.EMAIL')" autocomplete="username" name="email" required />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.PHONE')" name="phone" />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.VAT_ID')" name="vatId" required type="text" />
  <SfFormInput :label="$t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_REG_NR')" name="rpwdlNumber" required type="text" />
  <SfFormSelect :label="$t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_REG_AGENCY')" :options="registerAgencies" name="rpwdlRegisterAgency" required />

  <SfFormSelect
    v-if="data.rpwdlMedicalType !== 'medicalProvider'"
    :label="$t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_REG_GROUP')"
    :options="medicalPracticeGroups"
    name="rpwdlMedicalPracticeGroup"
    required
  />
  <span class="note">{{ $t('SHOP.COMMON.LABEL.MEDICAL_CONTRACTOR_REG_NOTICE') }}</span>
  <SfAddressForm :customerType :regions billable external-country="countryCode" external-type="type" readonly typed />
</template>

<style scoped>
  .note {
    font-size: 0.875rem;
    text-align: center;
  }
</style>